// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export default {
    apiKey: "AIzaSyBJQvcYvv3u8XHol96DOGHp666gA5fiLpM",
    authDomain: "madeall3d.com",
    projectId: "madeall",
    storageBucket: "madeall.appspot.com",
    messagingSenderId: "453827514389",
    appId: "1:453827514389:web:ce4be5450d3d256b937e1c",
    measurementId: "G-Z6NDNJ7T5G"
  };